var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',[_c('img',{attrs:{"alt":"zooplus logo","src":require("../assets/zooplus_logo.png")}})]),_c('h2',[_vm._v("Customer Historization")])])
}]

export { render, staticRenderFns }